import { withLatestFrom, mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { DetailsSidebarAction, detailsSidebarResourceIdSelector } from '@cbridge-packages/details-sidebar';
import { SymbolAction } from '@cbridge-packages/symbol';

type IState =
  IGetSelectorStateType<typeof detailsSidebarResourceIdSelector>;

export const closeCoreSymbolBeforeRemoveEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(SymbolAction.remove.started),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { symbolId } = payload;
    const openedDetailsId = detailsSidebarResourceIdSelector(state);
    if (openedDetailsId === symbolId) {
      return [
        DetailsSidebarAction.close({ skipUnsavedChangesConfirmation: true }),
      ];
    }

    return [];
  }),
);
